export const DropdownButtonTestAttributes = {
    popup: 'dropdown-button-popup',
};
